import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { getImageUrl, createFallbackImage } from '../utils/imageUtils';
import './Cart.css';

const Cart = () => {
  const { 
    cartItems, 
    cartOpen, 
    removeFromCart, 
    updateQuantity, 
    clearCart, 
    getTotalItems, 
    getTotalPrice, 
    toggleCart,
    setCartOpen
  } = useCart();
  const navigate = useNavigate();

  // Formatar preço em reais
  const formatPrice = (price) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(price);
  };

  if (!cartOpen) {
    return (
      <div className="cart-icon-container" onClick={toggleCart}>
        <div className="cart-icon">
          <i className="fas fa-shopping-cart"></i>
          {getTotalItems() > 0 && (
            <span className="cart-badge">{getTotalItems()}</span>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="cart-container">
      <div className="cart-header">
        <h2>Seu Carrinho</h2>
        <button className="close-cart" onClick={toggleCart}>
          <i className="fas fa-times"></i>
        </button>
      </div>

      {cartItems.length === 0 ? (
        <div className="empty-cart">
          <p>Seu carrinho está vazio</p>
          <button className="continue-shopping" onClick={toggleCart}>
            Continuar Comprando
          </button>
        </div>
      ) : (
        <>
          <div className="cart-items">
            {cartItems.map(item => (
              <div key={item.code} className="cart-item">
                <div className="cart-item-image">
                  <img 
                    src={getImageUrl(`/imagens/${item.code}.png`)} 
                    alt={item.name}
                    onError={(e) => {
                      if (e.target.src.endsWith('.png')) {
                        e.target.onerror = null;
                        e.target.src = e.target.src.replace('.png', '.jpg');
                      } else {
                        e.target.onerror = null;
                        e.target.src = createFallbackImage(item.name, 100, 100);
                      }
                    }}
                  />
                </div>
                <div className="cart-item-details">
                  <h3>{item.name}</h3>
                  <p className="cart-item-price">
                    {item.salePrice && item.salePrice < item.price 
                      ? formatPrice(item.salePrice) 
                      : formatPrice(item.price)}
                  </p>
                </div>
                <div className="cart-item-actions">
                  <div className="quantity-controls">
                    <button 
                      onClick={() => updateQuantity(item.code, item.quantity - 1)}
                      disabled={item.quantity <= 1}
                    >
                      -
                    </button>
                    <span>{item.quantity}</span>
                    <button 
                      onClick={() => updateQuantity(item.code, item.quantity + 1)}
                      disabled={item.quantity >= item.stock}
                    >
                      +
                    </button>
                  </div>
                  <button 
                    className="remove-item" 
                    onClick={() => removeFromCart(item.code)}
                  >
                    <i className="fas fa-trash-alt"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className="cart-summary">
            <div className="cart-total">
              <span>Total:</span>
              <span>{formatPrice(getTotalPrice())}</span>
            </div>
            <div className="cart-actions">
              <button
                className="continue-shopping"
                onClick={toggleCart}
              >
                Continuar Comprando
              </button>
              <button
                className="clear-cart"
                onClick={clearCart}
              >
                Limpar Carrinho
              </button>
              <button
                className="finish-order"
                onClick={() => {
                  setCartOpen(false);
                  navigate('/checkout');
                }}
              >
                Finalizar Compra
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Cart;
